'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './dynamic-page-list.routes';

export class DynamicPageListComponent {
  constructor(Auth, DynamicPageService, dialogs) {
    'ngInject';

    this.DynamicPageService = DynamicPageService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;

    this.DynamicPageService.query((data) => {
      this.data = data.filter(page => !page.type || page.type == 'page');
    }, err => {
      console.log("Could not retrieve dynamic pages.")
    })

  }

  delete(page) {
    var that = this;

    var pageText = "<br/><br/><b>" + page.name + "</b><br/><p>" + page.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Page?", "Do you really want to delete this page?" + pageText);
    dlg.result.then(() => {
      // OK delete it
      that.DynamicPageService.delete({id: page._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== page._id;
          });
        },
        err => {
          alert("Could not delete dynamic page");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduu.ap.dynamicPages.list', [uiRouter])
  .config(routes)
  .component('dynamicPageList', {
    template: require('./dynamic-page-list.html'),
    controller: DynamicPageListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/dynamic-pages/list/dynamic-page-list.component.js